
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/physical-notes",
      function () {
        return require("private-next-pages/physical-notes/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/physical-notes"])
      });
    }
  